import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create((colors) => ({
  divider: {
    height: 1,
    backgroundColor: colors.borderPrimary,
  },
}));
